var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1981 12L9.42886 7.89598C9.27424 7.73982 9.1875 7.52894 9.1875 7.30918C9.1875 7.08942 9.27424 6.87854 9.42886 6.72238C9.50479 6.64528 9.59529 6.58405 9.69511 6.54226C9.79492 6.50047 9.90205 6.47894 10.0103 6.47894C10.1185 6.47894 10.2256 6.50047 10.3254 6.54226C10.4252 6.58405 10.5157 6.64528 10.5917 6.72238L15.1877 11.412C15.3421 11.5685 15.4286 11.7795 15.4286 11.9994C15.4286 12.2192 15.3421 12.4303 15.1877 12.5868L10.5917 17.2764C10.5157 17.3535 10.4252 17.4147 10.3254 17.4565C10.2256 17.4983 10.1185 17.5198 10.0103 17.5198C9.90205 17.5198 9.79492 17.4983 9.69511 17.4565C9.59529 17.4147 9.50479 17.3535 9.42886 17.2764C9.27424 17.1202 9.1875 16.9093 9.1875 16.6896C9.1875 16.4698 9.27424 16.2589 9.42886 16.1028L13.1981 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/ChevronRight.54206598da6fc49183c1c3f9c7b0afd2.svg";
export { ForwardRef as ReactComponent };